import { UrlUtil } from "@core/utils";
import { envConfig } from "@env/env-config";
import { DefaultCatalogUtil } from "@modules/catalog/default-catalog-util";
import { productCatalogWithPagePath } from "@modules/catalog/product-catalog/model/domain/ProductCatalog";


export class FooterNormalController {

    public static $inject: Array<string> = ["pageContext", "$q", "$objectTree"];

    public qpmnDomain: string;

    public readonly rootPath: string;
    
    private defaultCatalogUrl: string;

    constructor(
        public pageContext: qpmn.main.IPageContext,
        public $q: angular.IQService,
        public $objectTree
    ) {
        this.rootPath = this.pageContext.rootPath;
        this.qpmnDomain = envConfig.getPath("", "");
    }
    
    public $onInit() {
        // let retCatalog = DefaultCatalogUtil.getDefaultCatalog(this.$objectTree, this.$q);
        // retCatalog.then((res) => {
        //     this.defaultCatalogUrl = UrlUtil.joinUrl([this.pageContext.rootPath, res.customizePath, (res.defaultCatalog as productCatalogWithPagePath).pagePath]);
        // }, (error) => {
        //     console.warn(error);
        // })
    }
}